// 電子發票錯誤碼中文對照
// 註：error_code 實際格式待後端確認，查表未命中時會 console.warn 提示
const EINVOICE_ERROR_MESSAGES = {
  E001: "目前無法驗證愛心碼",
  E003: "目前無法驗證發票資訊（店家尚未設定發票中心）",
  E004: "目前無法驗證發票資訊（店家尚未設定統一編號）",
  E005: "目前無法即時驗證載具",
  E006: "此店家不支援電子發票驗證",
  E007: "手機載具驗證失敗，請確認載具號碼",
  E008: "店家發票設定有誤，請聯繫店家",
  1002: "請輸入要驗證的手機載具或愛心碼",
  1003: "發票驗證資料錯誤，請重新輸入",
  2001: "查無店家資訊，請重新登入",
};

// 店家設定或部署狀態與使用者輸入是否正確無關，直接靜默放行
// 1002/1003/2001 為前端呼叫端或 token 範圍問題（理論上不該發生），
// 提示使用者也無從處理，同樣靜默放行，只留 console 供除錯
const SILENT_PASS_CODES = [
  "E001",
  "E003",
  "E004",
  "E006",
  "1002",
  "1003",
  "2001",
];

/**
 * 取得錯誤碼對應的中文訊息
 * 查不到時回傳 fallback，並印出 warn 供除錯
 */
export function getEinvoiceErrorMessage(errorCode, fallback) {
  const key = String(errorCode);
  const message = EINVOICE_ERROR_MESSAGES[key];
  if (!message) {
    console.warn(
      "[einvoice] 未知的 error_code，未命中中文對照表:",
      errorCode,
      "(type:", typeof errorCode, ") fallback:", fallback
    );
    return fallback;
  }
  return message;
}

/**
 * 從 axios error 取出後端錯誤 payload
 * 沒有 response（純網路錯誤／逾時）時回 null，
 * 避免把 axios 自己的 code 當成後端 error_code 查表
 */
export function getEinvoiceErrorData(error) {
  return error?.response?.data?.data ?? error?.response?.data ?? null;
}

/**
 * 是否需要呼叫驗證 API（僅光貿店家）
 */
export function shouldValidateEinvoiceCode(invoiceProviderType) {
  return invoiceProviderType === "guangmao";
}

/**
 * 是否為靜默放行的錯誤碼（不顯示警示）
 */
export function isSilentPassCode(errorCode) {
  return SILENT_PASS_CODES.includes(String(errorCode));
}

// 本次瀏覽階段已驗證通過的代碼（key: `${checkType}:${code}`）
// 只記錄成功結果，避免同一組號碼在模式頁與結帳頁重複轉打光貿；
// 僅存在記憶體，重新整理頁面即失效
const validatedCodes = new Set();

function buildValidatedKey(checkType, code) {
  return `${checkType}:${code}`;
}

export function isEinvoiceCodeValidated(checkType, code) {
  return validatedCodes.has(buildValidatedKey(checkType, code));
}

export function markEinvoiceCodeValidated(checkType, code) {
  validatedCodes.add(buildValidatedKey(checkType, code));
}
